import { connect } from "react-redux";
import Divergence from "./Divergence";


const mapStateToProps = (state) => ({
    fetchSelfVsOthersApi: state.BenchmarkFilteringReducer.fetchSelfVsOthersApi,

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(Divergence);
